import { styled } from '@mui/material';

import {
  ChkLogoWrapper,
  SMALL_PHONE_MEDIA_QUERY,
} from '@ui/checkout-components';

import { ChangeButton } from '../ChangeButton/ChangeButton';

import type { CardContentProps } from './CardContent.types';

export function CardContent({
  children,
  disabled,
  isLoading,
  iconUrl,
  onChangeClick,
  changeLabel,
  changeButtonTestId,
  changeButtonAriaLabel,
}: CardContentProps) {
  return (
    <Wrapper disabled={disabled}>
      <Logo isLoading={isLoading} iconUrl={iconUrl} />
      <ContentContainer>{children}</ContentContainer>
      <ChangeButton
        disabled={disabled}
        onChangeClick={onChangeClick}
        changeLabel={changeLabel}
        changeButtonTestId={changeButtonTestId}
        changeButtonAriaLabel={changeButtonAriaLabel}
      />
    </Wrapper>
  );
}

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ disabled, theme }) => ({
  display: 'flex',
  cursor: 'pointer',
  justifyContent: 'flex-start',
  flexWrap: theme.zoom.isZoomed ? 'wrap' : 'nowrap',
  alignItems: 'center',
  gap: theme.spacing(5),
  padding: theme.spacing(5),
  ...(disabled && { pointerEvents: 'none' }),

  [`${SMALL_PHONE_MEDIA_QUERY}`]: {
    padding: theme.spacing(4),
  },
}));

const ContentContainer = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const Logo = styled(ChkLogoWrapper)(({ theme }) => ({
  minWidth: 'min(100%,5.6rem)',
  minHeight: 'min(100%,5.6rem)',
  display: 'none',

  [theme.breakpoints.up('2xs')]: {
    display: 'flex',
  },
}));
